/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-09-09 16:25:52
 * @LastEditors: voanit
 * @LastEditTime: 2021-12-10 14:18:50
 */
/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-06-11 09:47:19
 * @LastEditors: voanit
 * @LastEditTime: 2021-07-19 18:16:44
 */
export default [
  {
    path: '/products-info',
    name: 'products-info',
    meta: {
      name: '商品列表',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "products" */ '@/views/commodity-center/products/product-info/list/index.vue')
  },
  {
    path: '/products-info/add/:id',
    name: 'products-info-new',
    meta: {
      parentsName: 'products-info',
      name: '新建商品',
      backName: 'products-info',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "products" */ '@/views/commodity-center/products/product-info/addOrEdit/index.vue')
  },
  {
    path: '/products-info/add/:id',
    name: 'products-info-copy',
    meta: {
      parentsName: 'products-info',
      backName: 'products-info',
      name: '复制商品',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "products" */ '@/views/commodity-center/products/product-info/addOrEdit/index.vue')
  },
  {
    path: '/products-info/edit/:id',
    name: 'products-info-edit',
    meta: {
      parentsName: 'products-info',
      backName: 'products-info',
      name: '编辑商品',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "products" */ '@/views/commodity-center/products/product-info/addOrEdit/index.vue')
  },
  {
    path: '/products-info/detail/:id',
    name: 'products-info-detail',
    meta: {
      parentsName: 'products-info',
      backName: 'products-info',
      name: '商品详情',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "products" */ '@/views/commodity-center/products/product-info/detail/index.vue')
  },

  {
    path: '/product-manager',
    name: 'product-manager',
    meta: {
      name: '商品设置',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "products" */ '@/views/commodity-center/product-manager/index.vue')
  },
]
